import React, { Component } from 'react';

class About extends Component {
   render() {

      if (this.props.data) {
         var name = this.props.data.name;
         var profilepic = "images/" + this.props.data.image;
         var bio = this.props.data.bio;
         var phone = this.props.data.phone;
         var email = this.props.data.email;
         var resumeDownload = this.props.data.resumedownload;
      }

      return (
         <section id="about">
            <div className="row">
               <div className="three columns">
                  <img className="profile-pic" src={profilepic} alt="David Segal Profile Pic" />
               </div>
               <div className="nine columns main-col">
                  <h2>About Me</h2>

                  <p>{bio}</p>
                  <div className="row">
                     <div className="columns contact-details">
                        <h2>Contact Details</h2>
                        <p className="address">
                           <span>{phone}</span><br />
                           <span>{email}</span>
                        </p>
                     </div>
                     <div className="columns download">
                        <p>
                           <a href={"https://drive.google.com/uc?export=view&id=1ONKGmZsjkO_TmXChPSy0O7MG-NU2N2GR"} className="button"><i className="fas fa-download"></i>Download Resume</a>
                           <a href={"https://drive.google.com/uc?export=view&id=1M5lHgfywpVs-camNsrMMQHjdjmK-8aN4"} className="button"><i className="fas fa-download"></i>sample IME -spine -redacted</a>
                           <a href={"https://drive.google.com/uc?export=view&id=1v7pHS07cHCZmuCI-yQRPAKHGkOCFEARH"} className="button"><i className="fas fa-download"></i>Redacted IME sample -BRAIN</a>
                           <a href={"https://drive.google.com/uc?export=view&id=1g4Ep88BKsxoK72ydf9dgkMapP_degJjl"} className="button"><i className="fas fa-download"></i>IME follow up opinion redacted</a>
                        </p>
                     </div>
                  </div>
               </div>
            </div>

         </section>
      );
   }
}

export default About;
